import { render, staticRenderFns } from "./TheCurrencyChart.vue?vue&type=template&id=2edaee11&scoped=true"
import script from "./TheCurrencyChart.vue?vue&type=script&lang=js"
export * from "./TheCurrencyChart.vue?vue&type=script&lang=js"
import style0 from "./TheCurrencyChart.vue?vue&type=style&index=0&id=2edaee11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edaee11",
  null
  
)

export default component.exports